import { gql } from '@apollo/client';

export default gql`
  mutation disconnectStorage($providerType: String!) {
    disconnectStorage(input: { providerType: $providerType }) {
      success
    }
  }
`;
